/**
 * Portfolio component
 *
 * Highlights some of  your creations. These can be designs, websites,
 * open source contributions, articles you've written and more.
 *
 * This is a great area for you to to continually add to and refine
 * as you continue to learn and create.
 */

import React from "react";

/**
 * Desk image
 *
 * Below is a sample desk image. Feel free to update this to an image of your choice,
 * updating below imageAltText to string that represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
import image from "../images/design-desk.jpeg";

const imageAltText = "desktop with books and laptop";

/**
 * Project list
 *
 * An array of objects that will be used to display for your project
 * links section. Below is a sample, update to reflect links you'd like to highlight.
 */
const projectList = [
  {
    title: "Network Tracking using wireshark and google maps",
    description:
      "This project is about tracking the network packets using wireshark and plotting the source and destination IP addresses on google maps.",
    url: "https://github.com/Dhruv-proto/network-project",
  },
  {
    title: "Keylogger",
    description:
      "This project is about creating a keylogger using python which logs the keystrokes of the user and sends it to the attacker.",
    url: "https://github.com/Dhruv-proto/Keylogger_python",
  },
  {
    title: "Railway Ticket Reservation System",
    description:
      "This project is about creating a railway ticket reservation system using python.",
    url: "https://github.com/Dhruv-proto/Railway_Reservation",
  },
  {
    title: "Simple Notepad application",
    description:
      "This project is about creating a simple notepad application using C# and dotnet framework.",
    url: "https://github.com/Dhruv-proto/Notepad-project",
  },
];

const Portfolio = () => {
  return (
    <section className="padding" id="portfolio">
      <h2 style={{ textAlign: "center" }}>Portfolio</h2>
      <div style={{ display: "flex", flexDirection: "row", paddingTop: "3rem" }}>
        <div style={{ maxWidth: "40%", alignSelf: "center" }}>
          <img
            src={image}
            style={{ height: "90%", width: "100%", objectFit: "cover" }}
            alt={imageAltText}
          />
        </div>
        <div className="container">
          {projectList.map((project) => (
            <div className="box" key={project.title}>
              <a href={project.url} target="_blank" rel="noopener noreferrer">
                <h3 style={{ flexBasis: "40px" }}>{project.title}</h3>
              </a>
              <p className="small">{project.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
